'use strict';

module.exports = String.prototype.includes;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/string/var/nativeIncludes.js
// module id = 985
// module chunks = 0